import React from "react";
import {
  MdSearch,
  MdClear,
  MdFilterList,
} from "react-icons/md";

const SearchFilters = ({
  searchTerm,
  onSearchChange,
  showFilters,
  onToggleFilters,
  filterStatus,
  onFilterStatusChange,
  onResetFilters,
  filteredItemsCount,
  totalItemsCount,
  currentPage,
  itemsPerPage,
  filterOptions,
  placeholder = "Rechercher...",
  itemType = "élément"
}) => {
  return (
    <div className="mb-6 rounded-lg bg-white p-4 shadow-sm">
      <div className="mb-4 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
        {/* Champ de recherche */}
        <div className="relative w-full max-w-md">
          <MdSearch className="absolute left-3 top-1/2 -translate-y-1/2 transform text-lg text-gray-400" />
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder={placeholder}
            className="w-full rounded-md border border-gray-300 py-2 pl-10 pr-4 focus:border-[#2ca01c] focus:outline-none focus:ring-2 focus:ring-[#2ca01c]/20"
          />
          {searchTerm && (
            <button
              onClick={() => onSearchChange("")}
              className="absolute right-3 top-1/2 -translate-y-1/2 transform text-gray-400 hover:text-gray-600"
              aria-label="Effacer la recherche"
            >
              <MdClear />
            </button>
          )}
        </div>

        {/* Bouton filtres */}
        <button
          onClick={onToggleFilters}
          className={`flex items-center rounded-md border ${
            showFilters
              ? "border-[#2ca01c] bg-[#2ca01c]/10 text-[#2ca01c]"
              : "border-gray-300 bg-white text-gray-700"
          } px-4 py-2 transition-colors`}
        >
          <MdFilterList className="mr-2" />
          Filtres{" "}
          {filterStatus !== "all" && (
            <span className="ml-1 rounded-full bg-[#2ca01c] px-2 text-white">
              1
            </span>
          )}
        </button>

        {/* Bouton réinitialiser */}
        {(searchTerm || filterStatus !== "all") && (
          <button
            onClick={onResetFilters}
            className="flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-gray-700 transition-colors hover:bg-gray-50"
          >
            <MdClear className="mr-2" />
            Réinitialiser
          </button>
        )}
      </div>

      {/* Options de filtrage par statut */}
      {showFilters && filterOptions && (
        <div className="animate-fadeIn mt-3 border-t border-gray-100 pt-3">
          <p className="mb-2 font-medium text-gray-700">
            Filtrer par statut:
          </p>
          <div className="flex flex-wrap gap-2">
            {filterOptions.map((option) => (
              <button
                key={option.value}
                onClick={() => onFilterStatusChange(option.value)}
                className={`rounded-md px-3 py-1 text-sm ${
                  filterStatus === option.value
                    ? `${option.activeClass} text-white`
                    : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                }`}
              >
                {option.label}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Résumé des résultats */}
      <div className="mt-4 flex items-center justify-between border-t border-gray-100 pt-3 text-sm text-gray-500">
        <p>
          {filteredItemsCount} {itemType}
          {filteredItemsCount !== 1 ? "s" : ""} trouvé
          {filteredItemsCount !== 1 ? "s" : ""}
          {searchTerm || filterStatus !== "all"
            ? " avec les filtres actuels"
            : ""}
        </p>

        {filteredItemsCount > 0 && (
          <div className="flex items-center">
            <p className="text-xs text-gray-500">
              Affichage{" "}
              {Math.min(
                (currentPage - 1) * itemsPerPage + 1,
                filteredItemsCount
              )}{" "}
              - {Math.min(currentPage * itemsPerPage, filteredItemsCount)}{" "}
              sur {filteredItemsCount}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchFilters;